import React, { useState } from "react";
import { useHistory } from "react-router";
import { useForm } from "react-hook-form";
import { Button } from "react-bootstrap";
import { LoginPostApi } from "../../../Api/PanelAdminServices";
import Style from "./LoginForm.module.scss";
import { KeyFill, PersonFill } from "react-bootstrap-icons";
import { errorToast, succToast } from "../../../Utils/Toast/Toast";
const LoginForm = () => {
  const[disable,setDisable]=useState(false)
  let history = useHistory();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    setDisable(true)
    let info = {
      password: data.password,
      phone: data.username,
    };
    LoginPostApi(info, (suc) => {
      if (suc.status === 1) {
        succToast(suc.message);
        setDisable(false)
        localStorage.setItem("adminToken", suc.token);
        setTimeout(() => {
          history.push("/activeorderfood");
        }, 2000);
      } else {
        errorToast(suc.message);
        setDisable(false)
      }
    });
  };
  return (
    <div className={Style.componentHolder}>
      <div className={Style.imgHolder}>
        <img src={"Assets/images/Login/login.svg"} alt="barest" />
      </div>
      <div className={Style.center}>
        <div className={Style.logoHolder}>
          <img src={"Assets/images/LogoBarest/ENlogo.svg"} alt="" />
        </div>
        <div className={Style.formHolder}>
          <form onSubmit={handleSubmit(onSubmit)} className={Style.formPart}>
            <div
              className={errors.username ? Style.isInvalid : Style.inputHolder}
            >
              <PersonFill className={Style.iconStyle} />
              <input
                {...register("username", { required: true })}
                type="text"
                className={Style.valid}
                // onChange={(e) => setPhone(e.target.value)}
                size="large"
                placeholder="username"
                // value={phone}
              />
            </div>
            <div
              className={errors.password ? Style.isInvalid : Style.inputHolder}
            >
              <KeyFill className={Style.iconStyle} />
              <input
                {...register("password", { required: true })}
                type="password"
                className={Style.valid}
                // onChange={(e) => setPassword(e.target.value)}
                size="large"
                placeholder="password"
                // value={password}
              />
            </div>
            <Button
              style={{ background: "#c20c64", border: "none" }}
              type="submit"
              disabledprops={disable}
            >
              ورود
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;
